import skyImgRotate from '@/components/iglobalwin/formComponents/sky-img-preview.vue';
import uploadService from 'sky-ossupload';
import { getDomain } from 'sky-domain';
import OSS from 'ali-oss';
import skyRequest from 'skytech-request';

export default {
	props: {
		value: {
			required: true,
		},
		limit: {
			required: false,
		},
		readOnly: {
			required: false,
		},
		bucketType: {
			required: false,
		},
		automistake: {
			required: false,
		},
		uploadSuccess: {
			required: false,
		},
		removeSuccess: {
			required: false,
		},
		platform: {
			required: false,
			default: 'iglobalwin-pub-oss',
		},
		single: {
			required: false,
			default: false,
		},
		accept: {
			required: false,
		},
		action: {
			required: false,
			default: '',
		},
		envType: {
			required: false,
			default: '1',
		},
		system: {
			required: false,
			default: 'iglobalwin',
		},
		judgeType: {
			required: false,
			default: '',
		},
		judgeSize: {
			required: false,
			default: 0,
		},
		errorCallback: {
			required: false,
		},
		uploadProgress: {
			required: false,
		},
		fileName: {
			required: false,
		},
		showFileInfo: {
			required: false,
			default: false,
		},
	},
	components: {
		skyImgRotate,
	},
	data() {
		return {
			isTrue: false, //错误边框显示
			dialogVisible: false, //查看大图详情
			dialogImgUrl: '',
			fileList: [],
			ossKey: '',
			isImg: '',
			downurl: '',
			editorFileList: [],
			filename: '',
			currentFile: {},
			uploadStatus: true,
		};
	},
	computed: {
		getClass() {
			let count = this.getFileList ? this.getFileList.length : 0;
			if (this.limit && this.limit == count) {
				//限制添加图片
				return ['hide-add-btn', 'uploadImg'];
			} else {
				return ['uploadImg'];
			}
		},
		getFileList() {
			return this.editorFileList;
		},
	},
	watch: {
		value(newVal) {
			if (JSON.stringify(newVal) !== JSON.stringify(this.getFileList)) {
				this.editorFileList = this.value.concat();
				this.fileList = [];
			}
		},
	},
	mounted() {
		this.editorFileList = this.value.concat();
		if (this.value.length != 0) this.selectFile = this.value.concat()[0];
	},
	methods: {
		error() {
			console.log(arguments);
		},
		uploadSectionFile: async function (param) {
			let that = this;

			//自定义文件上传
			let fileObj = param.file;
			let { fileName, uploadProgress } = that;

			try {
				let oss = uploadService({
					request: skyRequest,
					getHost: getDomain,
					platform: that.platform || 'iglobalwin-pub-oss',
					// OSS,
				});

				let convert = await oss.convert({
					file: fileObj,
				});

				let filetype = true;
				let filesize = true;
				if (that.judgeType) {
					filetype = await oss.checkType({
						...convert,
						type: oss.typeMap[that.judgeType],
					});
				}
				if (that.judgeSize) {
					filesize = await oss.checkSize({
						...convert,
						size: that.judgeSize,
					});
				}
				if (!filetype) {
					if (that.errorCallback) return that.errorCallback(convert);
					that.$message.warning('文件类型不符');
					if (!that.errorCallback) throw new Error('文件类型不符');
					return false;
				}
				if (!filesize) {
					if (that.errorCallback) return that.errorCallback(convert);
					if (!that.errorCallback) throw new Error('文件大小不符');
					return false;
				}

				let files = await oss.fileUpload({
					...convert,
					OSS,
					uploadProgress,
					fileName,
				});

				that.ossKey = files.ossName;
				that.fileList = that.$refs.upload.uploadFiles;
				that.fileList.forEach(item => {
					if (item.name == fileObj.name) {
						item.ossName = that.ossKey;
						item.url = files.url;
					}
				});
				that.$message.success('文件上传成功');
				that.isTrue = false; //成功后取消错误提示框
				this.uploadStatus = true;
			} catch (e) {
				that.$refs.upload.uploadFiles = _.drop(this.$refs.upload.uploadFiles, 1);
				// that.$message.warning('文件上传失败');
				this.uploadStatus = false;
				// that.$message.warning('文件上传失败');
				console.error(e);
			}
		},
		preview(file) {
			//查看图片
			this.dialogImgUrl = file.url;
			this.filename = file.fileName;
			this.currentFile = file;
			this.dialogVisible = true;
		},
		download(file) {
			const a = document.createElement('a');
			a.style.display = 'none';
			fetch(file.url)
				.then(res => res.blob())
				.then(blob => {
					// 将链接地址字符内容转变成blob地址
					a.href = URL.createObjectURL(blob);
					a.download = file.fileName; // 下载文件的名字
					document.body.appendChild(a);
					a.click();
				});
		},
		remove(file) {
			//删除图片
			let index = _.findIndex(this.fileList, item => item === file);
			this.fileList.splice(index, 1);

			this.$emit('input', this.getFileList);
			this.removeSuccess && this.removeSuccess(file, index);
		},
		editorRemove(file, index) {
			let { selectFile, editorFileList } = this;

			if (file.ossName == selectFile.ossName) {
				if (index === 0 && editorFileList.length === 1) {
					this.selectFile = {
						jumpType: 1,
						oneContent: '',
						twoContent: '',
					};
				}
				if (index === 0 && editorFileList.length > 1) {
					this.selectFile = editorFileList[index + 1];
				}
				if (index > 0 && editorFileList.length > 1) {
					this.selectFile = editorFileList[index - 1];
				}
			}

			//编辑删除图片
			this.editorFileList.splice(index, 1);
			this.$emit('input', this.getFileList);
			this.removeSuccess && this.removeSuccess(...arguments);
		},
		success(response, file) {
			if (!this.uploadStatus) return false;
			let fileItem = {
				fileName: file.name,
				ossName: file.ossName,
				url: file.url,
				bannerId: '',
				jumpType: 1,
				oneContent: '',
				twoContent: '',
			};
			this.editorFileList.push(fileItem);
			this.selectFile = fileItem;
			this.uploadSuccess &&
				this.uploadSuccess(this.editorFileList[this.editorFileList.length - 1], this.getFileList);
			// this.value.concat(tepmFileList)
			this.$emit('input', this.getFileList);
		},
	},
};
